import React, { useState, useEffect } from 'react'
import Box from '@mui/joy/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Chip, IconButton } from '@mui/joy';
import * as apiUtility from '../../config/APIUtils';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PolicyAgreement from './PolicyAgreement';
import CloseIcon from '@mui/icons-material/Close';
import SuccessPopUp from '../Utility/SuccessPopUp';
import ErrorPopUp from '../Utility/ErrorPopUp';
import UserPolicyHistory from './UserPolicyHistory';
import { useUser } from '../../config/UserContext';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Alert, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Row } from 'react-bootstrap';
import HelpIconInfo from '../Utility/HelpIconBox';



export default function PolicyDetails() {

    const SAVE_USER_POLICY_REGISTRATION = "policy/saveUserPolicyRegistration";
    const FETCH_POLICY_REGISTRATION_HISTORY = "policy/getRegistrationHistory";

    const [policyViewModal, setPolicyViewModal] = useState(false);
    const [policyViewData, setPolicyViewData] = useState({});

    const [policyHistoryModal, setPolicyHistoryModal] = useState(false);
    const [policyHistoryData, setPolicyHistoryData] = useState([]);
    const [policyRowData, setPolicyRowData] = useState({});

    const [showSuccess, setShowSuccess] = useState(false);
    const [successMsg, setsuccessMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [errorAlert, setErrorAlert] = useState(false);
    const [errorAlertMsg, setErrorAlertMsg] = useState('');

    const { userData, roleDetail, homeDetail, pendingPolicyCount, policyDataList, updateCurrentPolicyDataList, updatePendingPolicyCount } = useUser();

    var roleId = roleDetail.roleId;
    var homeId = String(homeDetail.homeId);
    var userId = userData.user_id;
    
    useEffect(() => {

        if (homeId !== 0 && roleId !== 0 && homeId !== "0" && roleId !== "0") {
            if(policyDataList === undefined && policyDataList.length === 0){
                setErrorAlertMsg("No policies found for the selected Home and Role.");
                setErrorAlert(true);
            } else {
                setErrorAlert(false);
            }
        }else{
            updateCurrentPolicyDataList([]);
        }
    }, [policyDataList]);


    

    const updateRowStatus = (rowDataResponse) => {
        console.log(rowDataResponse);

        updateCurrentPolicyDataList(prevRows => 
            prevRows.map(row => 
            row.policyId === rowDataResponse.policyId ? { ...row, status: 'Validated', expiry_date: row.expiry_date } : row
            )
        );

        updatePendingPolicyCount(pendingPolicyCount-1);
    }

    const handleAccept = () => {
        setPolicyViewModal(false);
        setShowErrorMsg(false);

        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = SAVE_USER_POLICY_REGISTRATION;
        apiRequest.data = { roleId: roleId, homeId: homeId, userId: userId, policyData: policyViewData };
        apiUtility.sendAPIDataPOST(apiRequest).then(resp => {
            let res = resp.data;
            if (res.message !== undefined && res.message === "Success") {
                updateRowStatus(res.data);
                setsuccessMsg("Home Doc acceptance saved successfully");
                setShowSuccess(true)
            } else {
                setErrorMsg("Error while accepting the policy");
                setShowErrorMsg(true)
            }
        })
            .catch(err => {
                setErrorMsg("Error while accepting the policy");
                setShowErrorMsg(true)
            });
    };

    const showRegistrationHistory = (policyDetails) => {
        setErrorAlert(false);
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = FETCH_POLICY_REGISTRATION_HISTORY;
        apiRequest.data = { roleId: roleId, homeId: homeId, userId: userId, policyId: policyDetails.policyId };
        apiUtility.sendAPIDataPOST(apiRequest).then(resp => {
            let res = resp.data;
            if (res.message !== undefined && res.message === "Success") {
                setPolicyRowData(policyDetails)
                setPolicyHistoryData(res.data)
                setPolicyHistoryModal(true)
                //console.log("History - ", res.data)
            } else {
                setErrorAlertMsg("Error while fetching Policy registrations");
                setErrorAlert(true)
            }
        })
            .catch(err => {
                setErrorAlertMsg("Error while fetching Policy registrations");
                setErrorAlert(true)
            });
    };

    const columns = [
        {
            field: 'policyId',
            headerName: 'Doc Code',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            hideable: false,
            renderCell: (params) => (
                <IconButton color="primary" sx={{
                                        borderRadius: "30px",
                                        height: "0.6em",
                                        maxHeight: "1.2em",
                                        padding: "1px 10px",
                                        "fontSize": 'var(--joy-fontSize-sm, 0.9em)'
                                    }} size="sm" variant="outlined" onClick={() => {
                        let rowData = params.row;
                        rowData["accepted"] = false;

                        if(params.row.verification === 'Validated')
                            rowData.accepted = true

                        setPolicyViewData(rowData);
                        setPolicyViewModal(true);
                    }} >
                                        <Typography variant="body-md" sx={{color:"#016799"}}> 
                                            <LaunchRoundedIcon sx={{ height: "0.7em" }} />
                                            {params.row.policyId}
                                        </Typography>
                                </IconButton>
            ),

        },
        {
            field: 'title',
            headerName: 'Title',
            width: 280,
            editable: true,
            headerAlign: 'center',
            hideable: false,
            renderCell: (params) => (
                            <Typography variant="body2" title={params.row.title} sx={{
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',    
                                    overflowWrap: 'break-word', 
                                    lineHeight: 1.3,
                                }}>
                                {params.row.title}
                            </Typography>
                        )
        },
        {
            field: 'policyNumber',
            headerName: 'Version',
            width: 120,
            editable: true,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 180,
            editable: true,
            align: 'center',
            headerAlign: 'center',
        },
        // {
        //     field: 'description',
        //     headerName: 'Description',
        //     description: 'This column has a value getter and is not sortable.',
        //     sortable: false,
        //     width: 250,
        //     headerAlign: 'center',
        //     //valueGetter: (value, row) => `${row?.firstName || ''} ${row?.lastName || ''}`,
        // },
        {
            headerName: 'Valid For',
            description: 'This column depicts the validity of each Doc',
            sortable: false,
            width: 130,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (

                    rowData.expiry === '0' ? (
                        <></>
                    ) : rowData.expiryType === 'months' ? (

                        <Chip color="primary"
                            size='sm' variant="soft" >
                            <TimerOutlinedIcon sx={{ height: "0.6em" }} />{rowData.expiry+" months"}</Chip>
                    ) : (
                        <Chip color="primary" size="sm" variant="soft">
                            <TimerOutlinedIcon sx={{ height: "0.6em" }} />{rowData.expiry+" year(s)"}&nbsp;</Chip>
                    )
                );
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            description: 'This column depict status of completed Home Doc',
            sortable: true,
            width: 130,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    rowData.status === undefined || rowData.status === 'Pending' || rowData.status === 'Assigned' ? (
                        <Chip color="warning" size="sm" variant="soft">
                            <MoreHorizRoundedIcon sx={{ height: "0.6em" }} />Due&nbsp;&nbsp;&nbsp;&nbsp;</Chip>

                    ) : rowData.status === 'Validated' ? (

                        <Chip color="success" size='sm' variant="soft"><CheckRoundedIcon sx={{ height: "0.6em" }} />Accepted</Chip>
                    ) : (
                        <Chip color="danger" size="sm" variant="soft"><CloseIcon sx={{ height: "0.6em" }} />Expired&nbsp;&nbsp;</Chip>
                    )
                );
            }
        },
        {
            field: 'expiry_date',
            headerName: 'Expiry Date',
            description: 'This column depicts expiry date of completed Home doc',
            sortable: true,
            width: 130,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    rowData.expiry_date === undefined || rowData.expiry_date === '' ? "" : <Typography variant="overline"> {new Date(rowData.expiry_date).toLocaleDateString()}</Typography>
                );
            }
        },
        {
            field: 'history',
            headerName: 'View',
            description: 'Depicts user home doc registration history',
            sortable: false,
            width: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;

                return (

                    <IconButton color={"primary"} sx={{
                        borderRadius: "30px",
                        height: "0.6em",
                        maxHeight: "1.2em",
                        padding: "1px 10px",
                        "fontSize": 'var(--joy-fontSize-sm, 0.9em)'
                    }} size="sm" variant="outlined" onClick={() => showRegistrationHistory(rowData)} >
                        <Typography variant="caption" sx={{color:"#016799"}}> <SystemUpdateAltOutlinedIcon sx={{ height: "0.7em" }} />History&nbsp;</Typography></IconButton>


                );
            }
        },
    ];

    function CustomNoRowsOverlay() {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography gutterBottom><ErrorOutlineIcon style={{ fontSize: "2pc" }} /></Typography>
            <Typography variant="h6" color="text.secondary">
                No Home Docs assigned for this role
            </Typography>
            <Typography variant="body2" color="text.secondary">
                This home has not assigned any home specific documents to this Role for you to review.
            </Typography>
            </Box>
        );
    }



    return (
        <>
        <Row style={{ paddingLeft: "1pc" }}>
            <HelpIconInfo link={"https://carepassportcareltc.atlassian.net/wiki/external/ODVhOTY2YzFhNDg4NGFhZDlkZjkwMWNkYTBkODgxYjc"} msg={"Review Assigned Home Docs"} />
        </Row>
            <Box
                sx={{
                    flexGrow: 1,
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    bgcolor: `${'var(--colors-index)'}.500`,
                    height: 500,
                    width: "98%",
                    margin: "auto",
                    mt: 2,
                    "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#016799", // header color
                    color: "#fff",
                    borderRadius: "4px 4px 0 0", // rounded top corners
                    },
                    "& .MuiDataGrid-columnSeparator": {
                    display: "none", // cleaner header look
                    },
                    "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #e0e0e0",
                    },
                    "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f5faff", // light hover
                    },
                    
                }}
                
            >

                {(errorAlert) && <><Alert severity="error" className='text-center'>{errorAlertMsg}</Alert> <br></br></>}
               
                <DataGrid
                    rows={policyDataList}
                    columns={columns}
                    getRowId={(row) => row._id}
                    slots={{
                        variant: 'linear-progress',
                        noRowsVariant: 'skeleton',
                        noRowsOverlay: CustomNoRowsOverlay,

                    }}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 20,
                            },
                        },
                    }}
                    pageSizeOptions={[5, 20, 50]}
                    sx={{ maxHeight:1200,
                        '& .MuiTablePagination-selectLabel ' : {pt:'0.9rem', color: '#016799'},
                        '& .MuiTablePagination-displayedRows' : {pt: '0.9rem', color:"#016799"},
                        '--DataGrid-overlayHeight': '300px',
                        // '.MuiDataGrid-virtualScrollerContent': {
                        //     minHeight: 'var(--DataGrid-overlayHeight)',
                        // },
                        // '.MuiDataGrid-overlayWrapper': {
                        //     position: 'absolute',
                        //     height: 'auto',
                        // },
                    }}
                    disableRowSelectionOnClick
                />

            </Box>
            <PolicyAgreement open={policyViewModal} onClose={() => setPolicyViewModal(false)} policy={policyViewData} onAccept={handleAccept} />
            <SuccessPopUp show={showSuccess} data={successMsg} onHide={() => { setShowSuccess(false) }} />
            <ErrorPopUp show={showErrorMsg} data={errorMsg} onHide={() => { setShowErrorMsg(false) }} />
            <UserPolicyHistory open={policyHistoryModal} onClose={() => setPolicyHistoryModal(false)} policyData={policyRowData} history={policyHistoryData} />
        </>
    );
}
